import type { RootState } from '@/app/store';
import type { User } from '../types/session.types';
import type { Roles } from '@/utils/enums';

export const selectSessionLoading = (state: RootState): boolean =>
  state.session.loading;

export const selectSessionUser = (state: RootState): User | null =>
  state.session.user;

export const selectUserRole = (state: RootState): Roles => state.session.role;

export const selectUserAuthorized = (state: RootState): boolean =>
  state.session.isAuthorized;

export const selectIsAppInitialized = (state: RootState): boolean =>
  state.session.isAppInitialized;
